import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, API, CATEGORY_LABELS, STATUS_LABELS, formatApiError } from "@/lib/api";
import { OnboardingBox } from "@/components/admin/OnboardingBox";

export const AgentApplicationDialog = ({ id, onClose, onChange }) => {
  const [a, setA] = useState(null);
  const load = useCallback(() => {
    api.get(`/agent/applications/${id}`).then((r) => setA(r.data)).catch(() => { toast.error("Candidatura non trovata"); onClose(); });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);

  const setStatus = async (status) => {
    try {
      await api.patch(`/agent/applications/${id}`, { status });
      load(); onChange();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };
  const editable = a?.category === "F_170_185";
  const rows = a ? [["Categoria", CATEGORY_LABELS[a.category]?.it], ["Nota", a.status_note], ["Altezza", `${a.height} cm`], ["Data di nascita", a.birth_date ? `${a.birth_date} (${a.age} anni)` : a.age],
    ["Genitore/tutore", a.is_minor ? `${a.parent_name} · ${a.parent_email} · ${a.parent_phone}` : ""], ["Mother agency", a.mother_agency || "Nessuna"], ["Email", a.email],
    ["Telefono", a.phone], ["Città", a.city], ["Nazionalità", a.nationality], ["Instagram", a.instagram], ["Messaggio", a.message]] : [];

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="agent-application-dialog" className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-none bg-white" data-lenis-prevent>
        {!a ? <DialogTitle className="font-mono text-xs font-normal">Caricamento…</DialogTitle> : (
          <div className="space-y-6">
            <DialogHeader><DialogTitle className="font-display text-5xl uppercase leading-none">{a.first_name} {a.last_name}</DialogTitle></DialogHeader>
            {editable && a.has_video && <video controls preload="metadata" src={`${API}/agent/applications/${a.id}/video`} data-testid="agent-application-video" className="max-h-[60vh] w-full bg-black" />}
            {editable && (
              <div className="grid grid-cols-3 gap-2" data-testid="agent-application-photos">
                {(a.photos || []).map((p, i) => <img key={i} src={p} alt={`Foto ${i + 1}`} className="aspect-[3/4] w-full object-cover" />)}
                {!a.photos?.length && <p className="col-span-3 font-serif italic">Nessuna foto caricata.</p>}
              </div>
            )}
            <table className="w-full"><tbody>
              {rows.map(([k, v]) => (
                <tr key={k} className="border-b border-[#1c1418]/15"><td className="py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#1c1418]/60">{k}</td><td className="py-2 text-right">{v || "—"}</td></tr>
              ))}
            </tbody></table>
            {editable ? (
              <div className="flex flex-wrap gap-2">
                {["approved", "rejected"].map((k) => (
                  <button key={k} onClick={() => setStatus(k)} data-testid={`agent-status-${k}`}
                    className={`px-5 py-3 font-mono text-xs uppercase tracking-[0.15em] ${a.status === k ? "bg-[#1c1418] text-white" : "border border-[#1c1418]/30"}`}>{STATUS_LABELS[k]}</button>
                ))}
              </div>
            ) : <p className="font-mono text-xs uppercase tracking-[0.15em]">Stato: {STATUS_LABELS[a.status]}</p>}
            {editable && a.status === "approved" && <OnboardingBox appId={a.id} scope="agent" />}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
